// Styles de l'écran CNO.

export const cnoResponsiveCss = `
                @media (max-width: 900px) {
                    .cno-workspace {
                        grid-template-columns: 1fr !important;
                    }
                    .cno-sidebar {
                        position: static !important;
                        max-height: none !important;
                    }
                    .cno-row {
                        grid-template-columns: 34px minmax(0, 1fr) !important;
                        align-items: stretch !important;
                    }
                    .cno-row label,
                    .cno-row .cno-save-badge {
                        grid-column: 2;
                    }
                    .cno-row .cno-delete-button {
                        grid-column: 2;
                        justify-self: start;
                    }
                }
            `;

export const pageStyle = { padding: "24px", background: "#f8fafc", minHeight: "100%", boxSizing: "border-box" };
export const headerStyle = { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "16px", flexWrap: "wrap", marginBottom: "22px" };
export const titleStyle = { margin: 0, fontSize: "28px", color: "#111827" };
export const subtitleStyle = { color: "#6b7280", margin: "6px 0 0" };
export const workspaceStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(220px, 280px) minmax(0, 1fr)",
    gap: "16px",
    alignItems: "start",
};
export const sidebarStyle = {
    display: "grid",
    position: "sticky",
    top: "16px",
    alignSelf: "start",
    background: "white",
    border: "1px solid #e2e8f0",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 4px 16px rgba(15,23,42,.05)",
    maxHeight: "calc(100vh - 140px)",
};
export const patientListHeaderStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px", borderBottom: "1px solid #edf0f4" };
export const patientListBodyStyle = { padding: "8px", overflowY: "auto", maxHeight: "calc(100vh - 220px)" };
export const patientListItemStyle = active => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "11px",
    border: 0,
    borderRadius: "10px",
    padding: "10px",
    background: active ? "#eef2ff" : "transparent",
    boxShadow: active ? "inset 3px 0 0 #6366f1" : "none",
    textAlign: "left",
    cursor: "pointer",
    marginBottom: "3px",
});
export const miniAvatarStyle = active => ({
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: "11px",
    flexShrink: 0,
    background: active ? "#6366f1" : "#eef2ff",
    color: active ? "white" : "#4f46e5",
});
export const patientNameStyle = active => ({
    display: "block",
    color: active ? "#312e81" : "#253047",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
});
export const patientDetailStyle = { display: "block", color: "#8b94a5", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
export const detailStyle = {
    display: "grid",
    gap: "16px",
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "16px",
};
export const detailHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "14px",
    flexWrap: "wrap",
    paddingBottom: "12px",
    borderBottom: "1px solid #e5e7eb",
};
export const actionsStyle = { display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "flex-end" };
export const identityGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "12px",
};
export const cnoSectionStyle = { border: "1px solid #bfdbfe", borderRadius: "8px", overflow: "hidden", background: "#eff6ff" };
export const cnoHeaderStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px", background: "#dbeafe", borderBottom: "1px solid #bfdbfe" };
export const cnoRowsStyle = { display: "grid", gap: "10px", padding: "12px" };
export const cnoFooterStyle = { borderTop: "1px solid #bfdbfe", padding: "12px 14px", background: "#f8fafc", display: "flex", gap: "8px", alignItems: "center" };
export const cnoRowStyle = {
    display: "grid",
    gridTemplateColumns: "34px minmax(180px, 1fr) minmax(120px, 180px) auto",
    gap: "12px",
    alignItems: "end",
    padding: "12px",
    border: "1px solid #dbeafe",
    borderRadius: "8px",
    background: "white",
};
export const lineIndexStyle = {
    width: "28px",
    height: "28px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eef2ff",
    color: "#4f46e5",
    fontWeight: 800,
    fontSize: "12px",
};
export const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    padding: "7px 8px",
    background: "white",
    color: "#111827",
    fontSize: "13px",
};
export const labelStyle = { display: "grid", gap: "5px", color: "#374151", fontSize: "12px", fontWeight: 600 };
export const primaryButtonStyle = { border: 0, borderRadius: "6px", padding: "8px 12px", background: "#4f46e5", color: "white", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" };
export const secondaryButtonStyle = { border: "1px solid #d1d5db", borderRadius: "6px", padding: "7px 11px", background: "white", color: "#374151", cursor: "pointer", whiteSpace: "nowrap" };
export const dangerButtonStyle = { border: "1px solid #991b1b", borderRadius: "6px", padding: "7px 11px", background: "#991b1b", color: "white", fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" };
export const contextMenuStyle = (x, y) => ({
    position: "fixed",
    left: x,
    top: y,
    zIndex: 1100,
    minWidth: "190px",
    padding: "6px",
    background: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    boxShadow: "0 18px 40px rgba(15,23,42,.18)",
});
export const contextMenuDangerItemStyle = {
    width: "100%",
    border: 0,
    borderRadius: "6px",
    padding: "9px 10px",
    background: "transparent",
    color: "#991b1b",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 800,
    textAlign: "left",
};
export const addProductButtonStyle = {
    padding: "10px 20px",
    borderRadius: "8px",
    border: "none",
    background: "#0f172a",
    color: "white",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
};
export const saveCnoButtonStyle = disabled => ({
    padding: "10px 18px",
    borderRadius: "8px",
    border: "1px solid #17B978",
    background: disabled ? "#e5e7eb" : "#17B978",
    color: disabled ? "#6b7280" : "#0C3B3C",
    fontSize: "14px",
    fontWeight: 800,
    cursor: disabled ? "not-allowed" : "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "110px",
    whiteSpace: "nowrap",
});
export const deleteLineButtonStyle = {
    border: "1px solid #fecaca",
    borderRadius: "6px",
    padding: "7px 10px",
    background: "#fef2f2",
    color: "#991b1b",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    alignSelf: "end",
};
export const saveBadgeStyle = status => {
    const palette = {
        dirty: { color: "#5A6D68", background: "#F4F1EA", border: "#d8d3c8" },
        saving: { color: "#0C3B3C", background: "#e8f3f1", border: "#b8d7d0" },
        saved: { color: "#0C3B3C", background: "#d8f5e8", border: "#17B978" },
        error: { color: "#991b1b", background: "#fef2f2", border: "#fecaca" },
    };
    const colors = palette[status] || palette.saved;
    return {
        minWidth: "100px",
        height: "32px",
        boxSizing: "border-box",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        border: `1px solid ${colors.border}`,
        borderRadius: "999px",
        padding: "0 10px",
        background: colors.background,
        color: colors.color,
        fontSize: "12px",
        fontWeight: 800,
        whiteSpace: "nowrap",
        alignSelf: "end",
    };
};
export const eyebrowStyle = { color: "#6366f1", textTransform: "uppercase", letterSpacing: ".08em", fontSize: "10px", fontWeight: 800 };
export const emptyStyle = { color: "#9ca3af", textAlign: "center", padding: "20px" };
export const noSelectionStyle = { minHeight: "320px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", border: "1px dashed #cbd5e1", borderRadius: "14px", background: "rgba(255,255,255,.65)", color: "#334155" };
export const backdropStyle = { position: "fixed", inset: 0, zIndex: 1000, background: "rgba(15, 23, 42, 0.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" };
export const modalStyle = { width: "520px", maxWidth: "calc(100vw - 40px)", maxHeight: "calc(100vh - 40px)", overflow: "auto", background: "white", borderRadius: "12px", boxShadow: "0 20px 50px rgba(0,0,0,.25)", padding: "20px" };
export const modalHeaderStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px", marginBottom: "20px" };
export const closeButtonStyle = { border: 0, background: "transparent", fontSize: "28px", cursor: "pointer", color: "#6b7280", lineHeight: 1 };
export const modalActionsStyle = { display: "flex", justifyContent: "flex-end", gap: "10px", flexWrap: "wrap" };
export const errorStyle = { color: "#b91c1c", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "7px", padding: "10px 12px", margin: 0 };
